export default class StocktakeItem {
  mapData(data) {
    this.id = data.id;
    this.stocktake_id = data.stocktake_id;
    this.product_id = data.product_id;
    this.product = data.product;
    this.expected_quantity = data.expected_quantity;
    this.physical_count = data.physical_count;
    this.variance = data.variance;
    this.spoilage_count = data.spoilage_count || 0;
    this.is_counted = data.is_counted || false;
    this.is_skipped = data.is_skipped || false;
    this.notes = data.notes;
    this.photo_url = data.photo_url;
    this.counted_at = data.counted_at;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.variance_percentage = data.variance_percentage;
    this.has_significant_variance = data.has_significant_variance || false;
  }

  // Calculate variance in real-time
  calculateVariance() {
    if (this.physical_count === null || this.physical_count === undefined) return null;
    return parseFloat(this.physical_count) - parseFloat(this.expected_quantity || 0);
  }

  // Calculate variance percentage
  calculateVariancePercentage() {
    const variance = this.calculateVariance();
    if (variance === null || this.expected_quantity === 0) return null;
    return Math.round((variance / this.expected_quantity) * 100);
  }

  // Get variance display with color coding
  getVarianceDisplay() {
    const variance = this.calculateVariance();
    if (variance === null) return { text: '-', color: 'text.secondary', severity: 'none' };
    
    const percentage = this.calculateVariancePercentage();
    const absPercentage = Math.abs(percentage);
    
    let color, severity;
    if (variance === 0) {
      color = 'success.main';
      severity = 'exact';
    } else if (absPercentage > 20) {
      color = 'error.main';
      severity = 'high';
    } else if (absPercentage > 10) {
      color = 'warning.main';
      severity = 'medium';
    } else {
      color = 'info.main';
      severity = 'low';
    }

    return {
      text: `${variance >= 0 ? '+' : ''}${variance.toFixed(2)} (${percentage}%)`,
      color,
      severity
    };
  }

  // Get status display
  getStatusDisplay() {
    if (this.is_skipped) return 'Bỏ qua';
    if (this.is_counted) return 'Đã kiểm';
    return 'Chưa kiểm';
  }

  // Get status display with color
  getStatusDisplayWithColor() {
    if (this.is_skipped) return { text: 'Đã bỏ qua', color: 'warning', icon: 'skip' };
    if (this.is_counted) return { text: 'Đã kiểm', color: 'success', icon: 'done' };
    return { text: 'Chưa kiểm', color: 'default', icon: 'pending' };
  }

  // Validation for count input
  isValidCount(count) {
    const num = parseFloat(count);
    return !isNaN(num) && num >= 0;
  }

  // Check if item has significant variance that needs attention
  hasSignificantVariance(threshold = 10) {
    const percentage = Math.abs(this.calculateVariancePercentage() || 0);
    return percentage > threshold;
  }

  // Format expected quantity for display
  getFormattedExpectedQuantity() {
    return parseFloat(this.expected_quantity || 0).toFixed(2);
  }

  // Format physical quantity for display
  getFormattedPhysicalQuantity() {
    if (this.physical_count === null || this.physical_count === undefined) return '-';
    return parseFloat(this.physical_count).toFixed(2);
  }

  // Format variance for display
  getFormattedVariance() {
    const variance = this.calculateVariance();
    if (variance === null) return '-';
    const percentage = this.calculateVariancePercentage();
    return `${variance >= 0 ? '+' : ''}${variance.toFixed(2)} (${percentage}%)`;
  }

  // Get product display name with code
  getProductDisplayName() {
    if (!this.product) return 'Unknown Product';
    return this.product.code ? 
      `${this.product.name} (${this.product.code})` : 
      this.product.name;
  }

  // Check if item needs recount (has been counted but has high variance)
  needsRecount(threshold = 15) {
    return this.is_counted && this.hasSignificantVariance(threshold);
  }
}